(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-brands"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const loader = document.getElementById("brands-loader");
  const swiperContainer = document.querySelector(".brands-swiper");

  if (!swiperContainer || typeof Swiper === "undefined") return;

  // Show loader until all images load
  window.addEventListener("load", () => {
    loader.style.opacity = "0";
    setTimeout(() => {
      loader.style.display = "none";
      swiperContainer.style.visibility = "visible";
    }, 400);
  });

  // Initialize Swiper
  const swiper = new Swiper(".brands-swiper", {
    slidesPerView: 8,
    spaceBetween: 15,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: { slidesPerView: 3 },
      480: { slidesPerView: 3 },
      630: { slidesPerView: 4 },
      768: { slidesPerView: 5 },
      992: { slidesPerView: 8 },
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const loader = document.getElementById("hero-loader");
  const hero = document.querySelector(".hero-swiper");

  if (!hero) return;

  window.addEventListener("load", function() {
    loader.style.opacity = "0";
    setTimeout(() => {
      loader.style.display = "none";
      hero.style.visibility = "visible";

      new Swiper(".myHeroSwiper", {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 700,
        effect: "slide",
      });
    }, 400);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bottom-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // NAV ITEM CLICK + HOVER
  document.querySelectorAll("li").forEach((li) => {
    li.addEventListener("click", function (e) {
      const hasDropdown = this.querySelector(".dropdown-sub.dropdown-menu");
      if (hasDropdown) {
        e.stopPropagation();
        const isActive = this.classList.contains("active");
        document.querySelectorAll("li.active").forEach((a) => a.classList.remove("active"));
        if (!isActive) this.classList.add("active");
      }
    });

    li.addEventListener("mouseenter", function () {
      if (this.querySelector(".dropdown-sub.dropdown-menu")) {
        document.querySelectorAll("li.active").forEach((a) => {
          if (a !== this) a.classList.remove("active");
        });
        this.classList.add("active");
      }
    });

    li.addEventListener("mouseleave", function () {
      if (this.querySelector(".dropdown-sub.dropdown-menu")) this.classList.remove("active");
    });
  });

  // OUTSIDE CLICK CLOSE (delay fix)
  document.addEventListener("click", () => {
    setTimeout(() => {
      document.querySelectorAll("li.active").forEach((a) => a.classList.remove("active"));
    }, 100);
  });

  // HAMBURGER MENU
  const checkbox = document.querySelector(".More-checkbox");
  const navbar = document.querySelector(".site-navbar");
  if (checkbox && navbar) {
    checkbox.addEventListener("change", () => {
      navbar.style.display = checkbox.checked ? "block" : "none";
    });
  }

  // MEGA TITLE TOGGLE (bottom navbar only)
  function initMegaToggle(selector) {
    const titles = document.querySelectorAll(selector);
    titles.forEach((title) => {
      title.addEventListener("click", function (e) {
        e.stopPropagation();
        if (window.innerWidth <= 991) {
          const current = this.closest(".mega-widget");
          const isActive = current.classList.contains("active");
          document.querySelectorAll(".mega-widget.active").forEach((w) => w.classList.remove("active"));
          if (!isActive) current.classList.add("active");
        }
      });
    });
  }

  initMegaToggle(".bottom-navbar-wrapper .site-navbar .navbar-nav .mega-col .mega-title");

  // FIXED: CATEGORY DROPDOWN ITEM ACTIVE HANDLER (runs in capture phase)
  const categoryItems = document.querySelectorAll(".categories-wrapper .dropdown-menu li.dropdown-item");

  categoryItems.forEach((item) => {
    item.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Remove active from all items
        document
          .querySelectorAll(".categories-wrapper .dropdown-menu li.dropdown-item.active")
          .forEach((el) => el.classList.remove("active"));

        // Add active to clicked item
        this.classList.add("active");

        // Force dropdown to stay open
        const parentDropdown = this.closest(".dropdown");
        if (parentDropdown) parentDropdown.classList.add("show");

        const dropdownMenu = parentDropdown?.querySelector(".dropdown-menu");
        if (dropdownMenu) dropdownMenu.classList.add("show");
      },
      true // capture phase ensures this runs before Bootstrap closes dropdown
    );
  });

  // REMOVE ACTIVE ON RESIZE
  window.addEventListener("resize", function () {
    if (window.innerWidth > 991) {
      document.querySelectorAll(".mega-widget.active").forEach((el) => el.classList.remove("active"));
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-notebooks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance = null;

  function initOrDestroySwiper() {
    const sliderEl = document.querySelector(".notebooks-slider");

    if (!sliderEl) return;

    if (window.innerWidth <= 991) {
      if (!swiperInstance) {
        swiperInstance = new Swiper(sliderEl, {
          slidesPerView: 1,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }

  initOrDestroySwiper();
  window.addEventListener("resize", initOrDestroySwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cute-stationary"] && !Shopify.designMode) return;
  try {
    
      (function () {
      const tablist = document.getElementById('myTab');
      if (!tablist) return;
      const buttons = Array.from(tablist.querySelectorAll('[role="tab"]'));
      buttons.forEach((btn, idx) => {
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            const next = buttons[(idx + 1) % buttons.length];
            next.focus(); next.click();
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            const prev = buttons[(idx - 1 + buttons.length) % buttons.length];
            prev.focus(); prev.click();
          }
        });
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-new"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const brandSelector = document.getElementById('brand-selector');
    if (brandSelector) {
      brandSelector.addEventListener('change', function () {
        const selectedValue = this.value;
        if (selectedValue) {
          window.location.href = selectedValue;
        }
      });
    }

    const input = document.getElementById('search-input');
    const cartCountEl = document.querySelector('.cart-count');
    const cartDrawer = document.getElementById('CartDrawer');
    const cartBtn = document.getElementById('cart-btn');
    const htmlEl = document.documentElement;

    function updateCartCount() {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((data) => {
          cartCountEl.textContent = data.item_count;
        })
        .catch(() => {});
    }
    updateCartCount();

    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then((res) => res.json())
          .then(() => {
            updateCartCount();
            if (cartDrawer) {
              cartDrawer.classList.add('drawer--is-open');
              cartDrawer.setAttribute('aria-hidden', 'false');
              cartDrawer.focus();
              htmlEl.classList.add('js-drawer-open', 'lock-scroll');
            }
          })
          .catch(() => {});
      });
    });

    if (cartBtn) {
      cartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (cartDrawer) {
          cartDrawer.classList.add('drawer--is-open');
          cartDrawer.setAttribute('aria-hidden', 'false');
          cartDrawer.focus();
          htmlEl.classList.add('js-drawer-open', 'lock-scroll');
        }
      });
    }

    document.querySelectorAll('.js-drawer-close').forEach((btn) => {
      btn.addEventListener('click', function () {
        cartDrawer.classList.remove('drawer--is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        htmlEl.classList.remove('js-drawer-open', 'lock-scroll');
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('button.js-qty__adjust--minus') || e.target.closest('.cart__remove')) {
        setTimeout(updateCartCount, 700);
      }
    });

    const text = 'Search products...';
    let i = 0, isTyping = true, lastTime = 0;
    const typingSpeed = 60, erasingSpeed = 30, pauseAfterTyping = 1500, pauseAfterErasing = 500;

    function animate(time) {
      if (!lastTime) lastTime = time;
      const delta = time - lastTime;
      if (isTyping && delta >= typingSpeed) {
        if (i < text.length) {
          i++;
          input.setAttribute('placeholder', text.substring(0, i));
          lastTime = time;
        } else {
          isTyping = false;
          lastTime = time + pauseAfterTyping;
        }
      } else if (!isTyping && delta >= erasingSpeed) {
        if (i > 0) {
          i--;
          input.setAttribute('placeholder', text.substring(0, i));
          lastTime = time;
        } else {
          isTyping = true;
          lastTime = time + pauseAfterErasing;
        }
      }
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);

    const wishlistBtn = document.getElementById('wishlist-btn');
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function (e) {
        e.preventDefault();
        alert('Wishlist popup will open here!');
        let countEl = document.querySelector('.wishlist-count');
        let current = parseInt(countEl.textContent);
        countEl.textContent = current + 1;
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
